import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {FinishedResponseInteractionService, WalkerService} from 'shared/services';
import type {StateProvider, Transition} from '@uirouter/angularjs';
import type RecordDataService from './record.data-service';
import {exists} from 'shared/utils/custom-utils';
import {getRecordPath} from 'shared/utils/data-service-utils';

/*@ngInject*/
export default function recordRoutes($stateProvider: StateProvider) {
    let recordDetailModule: { default: any; };

    $stateProvider
        .state('recordDetail', {
            url: '/records/:recordId?back&group&activeTab',
            params: {back: {dynamic: true}, group: {dynamic: true}, activeTab: {dynamic: true}},
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                /*@ngInject*/
                component: () => recordDetailModule.default,
                props: async ($transition$: Transition,
                              walker: WalkerService,
                              finishedResponseInteractionService: FinishedResponseInteractionService,
                              recordDataService: RecordDataService) => {

                    try {
                        const recordId = $transition$.params().recordId;
                        const detailView = await recordDataService.getRecordDetailView(recordId);

                        if ('sourceDocumentId' in detailView && exists(detailView.sourceDocumentId)) {
                            await walker.newPage(getRecordPath(detailView.sourceDocumentId));
                        }

                        return {detailView};
                    } catch (exceptionResponse) {
                        await finishedResponseInteractionService.showFailedInModalWindow(exceptionResponse);
                        throw exceptionResponse;
                    }
                }
            },
            lazyLoad: async () => {
                recordDetailModule = await import(/* webpackChunkName: "recordDetail" */ './kp-record-detail-page/KpRecordDetailPage.svelte');
                return null;
            }
        });
}